export default __webpack_public_path__ + "static/media/centos.c5283bf0.svg";